<template>
  <v-container>
    <app-navigation></app-navigation>
    <v-main class="pt-12">
      <div class="pt-md-5">
        <v-layout align-center justify-center row wrap>
          <v-flex xs12 class="mx-1 mb-1 pa-0">
            <main-sub-page-toolbar icon="mdi-wallet-giftcard">{{
              $t("dashboardCardSuperAdminGiftCardActive")
            }}</main-sub-page-toolbar>
          </v-flex>
          <v-flex xs12 class="mx-1 mb-1 pa-0">
            <div>
              <data-table-search-toolbar
                :search.sync="search"
              ></data-table-search-toolbar>
              <v-data-table
                :loading-text="$t('lmPleaseWait')"
                class="#505050--text"
                :class="
                  getTheme() == 'dark'
                    ? 'outlined elevation-0'
                    : 'flat elevation-0'
                "
                :style="
                  getTheme() == 'dark'
                    ? 'border: 1px solid darkgray; border-top: none; background-color: white'
                    : 'border: none; background-color: white'
                "
                :headers="headers"
                :items="$store.state.storeGiftCard.giftCard"
                :search="search"
                sort-by="validTo"
                :items-per-page="-1"
                must-sort
                show-expand
                :no-results-text="$t('dataGridSlotNoResults')"
                :no-data-text="$t('dataGridSlotNoData')"
                :footer-props="{
                  itemsPerPageText: $t('dataGridRowsPerPageText'),
                  itemsPerPageAllText: $t('dataGridRowsPerPageAllText'),
                }"
              >
                <template v-slot:expanded-item="{ item }">
                  <td :colspan="headers.length">
                    <div class="my-4">
                      <div>{{ item.fullName }}</div>
                      <div>{{ item.address1 }}</div>
                      <div>{{ item.address2 }}</div>
                      <div>{{ item.country }}</div>
                      <div>{{ item.phone }}</div>
                      <div>{{ item.email }}</div>
                    </div>
                    <div class="mb-4">
                      <div>{{ item.notes }}</div>
                    </div>
                  </td>
                </template>
                <template v-slot:item.value="{ item }">
                  <div class="my-4">{{ item.value }} {{ item.currency }}</div>
                </template>
                <template v-slot:item.actions="{ item }">
                  <div class="d-flex flex-no-wrap">
                    <v-icon class="mr-3" @click="copyItem(item)"
                      >mdi-content-copy</v-icon
                    >
                    <v-icon class="mr-3" @click="editItem(item)"
                      >mdi-pencil</v-icon
                    >
                    <v-icon @click="deleteItemSet(item.id)">mdi-delete</v-icon>
                  </div>
                </template>
                <template v-slot:item.closed="{ item }">
                  <v-icon
                    @click="
                      dialogClosed = true;
                      itemToClose = item;
                    "
                    :color="item.closed ? 'success' : 'error'"
                  >
                    {{
                      item.closed
                        ? "mdi-check-circle-outline"
                        : "mdi-close-circle-outline"
                    }}
                  </v-icon>
                </template>
                <template v-slot:item.timestamp="{ item }">{{
                  item.timestamp.seconds | formatDate
                }}</template>
                <template v-slot:item.validTo="{ item }"
                  >{{
                    Math.floor(
                      (item.validTo.seconds - new Date().getTime() / 1000) /
                        87840
                    )
                  }}
                  {{ $t("lmDays") }}</template
                >
              </v-data-table>
            </div>
            <!-- DELETE CONFIRM DIALOG -->
            <dialog-basic-yes-no
              :active="dialogDelete"
              @clickYes="deleteItem"
              @clickNo="dialogDelete = false"
              icon="mdi-comment-question-outline"
              :title="$t('msgQuestion')"
              >{{ $t("deleteDialogQuestion") }}</dialog-basic-yes-no
            >

            <!-- CLOSED CONFIRM DIALOG -->
            <dialog-basic-yes-no
              :active="dialogClosed"
              @clickYes="toggleGiftCardBooleanActive(itemToClose)"
              @clickNo="dialogClosed = false"
              icon="mdi-comment-question-outline"
              :title="$t('msgQuestion')"
              >{{ $t("giftCardCloseCardQuestionTitle") }}</dialog-basic-yes-no
            >
          </v-flex>
          <simple-navigation-button
            left
            :title="$t('lmBtnBack')"
            icon="mdi-arrow-left"
            @clicked="$router.push({ name: 'settingsSubMenuModuleGiftCard' })"
          ></simple-navigation-button>
          <!-- ADD / EDIT DIALOG -->
          <v-dialog
            v-model="dialog"
            max-width="500px"
            persistent
            transition="dialog-bottom-transition"
          >
            <template v-slot:activator="{ on }">
              <v-btn
                color="primary"
                v-on="on"
                @click="addItem"
                dark
                fixed
                bottom
                right
                rounded
              >
                <v-icon medium class="mr-1">mdi-plus</v-icon>
                {{ $t("lmBtnAdd") }}
              </v-btn>
            </template>
            <v-form ref="form" v-model="valid">
              <v-card
                :class="
                  getTheme() == 'dark'
                    ? 'outlined elevation-0'
                    : 'flat elevation-0'
                "
                :style="
                  getTheme() == 'dark'
                    ? ''
                    : 'border-bottom: 1px solid lightgray'
                "
              >
                <v-card-title
                  :style="
                    getTheme() == 'dark'
                      ? 'background-color: #505050'
                      : 'background-color: white; border-bottom: 1px solid lightgray'
                  "
                  :class="
                    getTheme() == 'dark' ? 'white--text' : '#505050--text'
                  "
                  class="title font-weight-regular"
                >
                  <v-icon
                    :class="
                      getTheme() == 'dark' ? 'white--text' : 'primary--text'
                    "
                    class="mr-3"
                    medium
                  >
                    {{ this.editedIndex == -1 ? "mdi-plus" : "mdi-pencil" }}
                  </v-icon>
                  {{ formTitle }}
                </v-card-title>
                <v-card-text class="py-0 pt-2">
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs12>
                        <v-menu
                          v-model="validFromPicker"
                          :close-on-content-click="false"
                          max-width="290"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              dense
                              :rules="[validateRequired()]"
                              :value="editedItem.timestamp | formatDate3"
                              :clearable="true"
                              :label="$t('giftCardAddedDateTitle')"
                              readonly
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="editedItem.timestamp"
                            @change="validFromPicker = false"
                            color="secondary"
                            :first-day-of-week="1"
                            :locale="language"
                            header-color="primary"
                          ></v-date-picker>
                        </v-menu>
                      </v-flex>
                      <v-flex xs12>
                        <v-menu
                          v-model="validToPicker"
                          :close-on-content-click="false"
                          max-width="290"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              dense
                              :rules="[validateRequired()]"
                              :value="editedItem.validTo | formatDate3"
                              :clearable="true"
                              :label="$t('giftCardValidToTitle')"
                              readonly
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="editedItem.validTo"
                            @change="validToPicker = false"
                            color="secondary"
                            :first-day-of-week="1"
                            :locale="language"
                            header-color="primary"
                          ></v-date-picker>
                        </v-menu>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          v-model="editedItem.code"
                          :label="$t('giftCardCodeTitle')"
                          :rules="[validateMaxLength(30)]"
                          :counter="30"
                          dense
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          v-model="editedItem.itemName"
                          :label="$t('giftCardItemNameTitle')"
                          :rules="[validateMaxLength(250)]"
                          :counter="250"
                          dense
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          v-model="editedItem.value"
                          :label="$t('giftCardValueTitle')"
                          :rules="[
                            validateRequired(),
                            validateIsCurrency(),
                            validateMaxLength(20),
                          ]"
                          :counter="20"
                          dense
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          v-model="editedItem.fullName"
                          :label="$t('giftCardFullNameTitle')"
                          :rules="[validateMaxLength(250)]"
                          :counter="250"
                          dense
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          v-model="editedItem.address1"
                          :label="$t('giftCardAddress1Title')"
                          :rules="[validateMaxLength(250)]"
                          :counter="250"
                          dense
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          v-model="editedItem.address2"
                          :label="$t('giftCardAddress2Title')"
                          :rules="[validateMaxLength(250)]"
                          :counter="250"
                          dense
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-select
                          item-text="title"
                          item-value="cShort"
                          :items="countryItems"
                          v-model="editedItem.country"
                          :label="$t('giftCardCountryTitle')"
                        ></v-select>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          v-model="editedItem.phone"
                          :label="$t('giftCardPhoneTitle')"
                          :rules="[validateMaxLength(250)]"
                          :counter="250"
                          dense
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          v-model="editedItem.email"
                          :label="$t('giftCardEmailTitle')"
                          :rules="[validateMaxLength(250)]"
                          :counter="250"
                          dense
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          v-model="editedItem.notes"
                          :label="$t('giftCardNotesTitle')"
                          :rules="[validateMaxLength(500)]"
                          :counter="500"
                          dense
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-switch
                          dense
                          style="height: 30px"
                          class="ma-0 pa-0"
                          v-model="editedItem.closed"
                          :label="$t('giftCardClosedTitle')"
                        ></v-switch>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions
                  :class="
                    getTheme() == 'dark' ? '#505050--text' : '#505050--text'
                  "
                  :style="
                    getTheme() == 'dark'
                      ? 'background-color: whitesmoke; border-top: 1px solid lightgray;'
                      : 'background-color: white; border-top: 1px solid lightgray;'
                  "
                >
                  <v-spacer></v-spacer>
                  <v-btn color="primary" class="my-1" text @click="close">
                    {{ $t("addEditFormCancelButton") }}
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn @click="save" color="primary" dark>
                    <v-icon medium class="mr-1">mdi-content-save</v-icon>
                    {{ $t("addEditFormSaveButton") }}
                  </v-btn>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-form>
          </v-dialog>
          <v-snackbar
            v-model="$store.state.storeSnackbar.snackbar.active"
            :color="$store.state.storeSnackbar.snackbar.color"
            :timeout="$store.state.storeSnackbar.snackbar.timeout"
            >{{ $store.state.storeSnackbar.snackbar.message }}</v-snackbar
          >
        </v-layout>
      </div>
    </v-main>
  </v-container>
</template>

<script>
import AppNavigation from "@/views/AppNavigation";
import MainSubPageToolbar from "@/components/MainSubPageToolbar";
import DialogBasicYesNo from "@/components/DialogBasicYesNo";
import SimpleNavigationButton from "@/components/SimpleNavigationButton";
import DataTableSearchToolbar from "@/components/DataTableSearchToolbar";
import moment from "moment";

export default {
  name: "settingsGiftCardActive",
  components: {
    AppNavigation,
    MainSubPageToolbar,
    DialogBasicYesNo,
    SimpleNavigationButton,
    DataTableSearchToolbar,
  },
  data() {
    return {
      valid: true,
      netBackImage: require("@/assets/netBack.png"),
      search: "",
      dialog: false,
      dialogDelete: false,
      dialogDeleteId: "",
      validFromPicker: false,
      validToPicker: false,
      language: "en",
      dialogClosed: false,
      itemToClose: "",
      headers: [
        {
          text: this.$t("giftCardAddedDateTitle"),
          align: "center",
          value: "timestamp",
          sortable: true,
        },
        {
          text: this.$t("giftCardCodeTitle"),
          align: "center",
          value: "code",
          sortable: true,
        },
        {
          text: this.$t("giftCardItemNameTitle"),
          align: "left",
          value: "itemName",
          sortable: true,
        },
        {
          text: this.$t("giftCardFullNameTitle"),
          align: "center",
          value: "fullName",
          sortable: true,
        },
        {
          text: this.$t("giftCardValueTitle"),
          align: "center",
          value: "value",
          sortable: true,
        },
        {
          text: this.$t("giftCardValidToTitle"),
          align: "center",
          value: "validTo",
          sortable: true,
        },
        {
          text: this.$t("giftCardClosedTitle"),
          align: "center",
          value: "closed",
          sortable: false,
        },
        {
          text: "",
          align: "center",
          sortable: false,
          value: "actions",
        },
        {
          text: this.$t("settingsDeliveryGridHeaderPaymentTypesShortTitle"),
          value: "data-table-expand",
        },
      ],
      editedIndex: -1,
      editedItem: {
        address1: "",
        address2: "",
        client: this.$store.state.storeClient.client.basicSettings.name,
        closed: false,
        code: "",
        country: "",
        currency:
          this.$store.state.storeClient.client.environmentSettings.currency,
        email: "",
        phone: "",
        fullName: "",
        itemName: "",
        notes: "",
        timestamp: "",
        validTo: "",
        value: 0,
        automaticInsert: false,
      },
      defaultItem: {
        address1: "",
        address2: "",
        client: this.$store.state.storeClient.client.basicSettings.name,
        closed: false,
        code: "",
        country: "",
        currency:
          this.$store.state.storeClient.client.environmentSettings.currency,
        email: "",
        phone: "",
        fullName: "",
        itemName: "",
        notes: "",
        timestamp: "",
        validTo: "",
        value: 0,
        automaticInsert: false,
      },
    };
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? this.$t("addEditFormAddingTitle")
        : this.$t("addEditFormEditingTitle");
    },
  },
  methods: {
    async toggleGiftCardBooleanActive(item) {
      this.dialogClosed = false;
      try {
        await this.$store.dispatch("toggleGiftCardBooleanActive", item);
      } catch (error) {
        this.$store.commit({
          type: "showSnackbar",
          color: "error",
          message: error,
        });
        return;
      }
    },
    addItem() {
      this.editedIndex = -1;
      this.defaultItem.timestamp = moment().format("YYYY-MM-DD");
      this.defaultItem.validTo = moment().format("YYYY-MM-DD");
      this.editedItem = Object.assign({}, this.defaultItem);
    },
    deleteItemSet(item) {
      this.dialogDelete = true;
      this.dialogDeleteId = item;
    },
    async deleteItem() {
      try {
        await this.$store.dispatch("removeGiftCard", this.dialogDeleteId);
        this.dialogDelete = false;
        this.dialogDeleteId = "";
      } catch (error) {
        this.$store.commit({
          type: "showSnackbar",
          color: "error",
          message: error,
        });
        return;
      }
      this.$store.commit({
        type: "showSnackbar",
        color: "success",
        message: this.$t("msgSuccessDelete"),
      });
    },
    copyItem(item) {
      this.editedItem = Object.assign({}, item);

      this.editedItem.timestamp = moment
        .unix(this.editedItem.timestamp.seconds)
        .format("YYYY-MM-DD");
      this.editedItem.validTo = moment
        .unix(this.editedItem.validTo.seconds)
        .format("YYYY-MM-DD");
      this.editedItem.value = String(this.editedItem.value);

      this.dialog = true;
    },
    editItem(item) {
      this.editedIndex = this.$store.state.storeGiftCard.giftCard.indexOf(item);
      this.editedItem = Object.assign({}, item);

      this.editedItem.timestamp = moment
        .unix(this.editedItem.timestamp.seconds)
        .format("YYYY-MM-DD");
      this.editedItem.validTo = moment
        .unix(this.editedItem.validTo.seconds)
        .format("YYYY-MM-DD");
      this.editedItem.value = String(this.editedItem.value);

      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
    },
    async save() {
      if (this.$refs.form.validate()) {
        if (this.editedIndex > -1) {
          try {
            await this.$store.dispatch("editGiftCard", this.editedItem);
            this.$store.commit({
              type: "showSnackbar",
              color: "success",
              message: this.$t("msgSuccessEdit"),
            });
          } catch (error) {
            this.$store.commit({
              type: "showSnackbar",
              color: "error",
              message: error,
            });
          }
        } else {
          try {
            await this.$store.dispatch("addGiftCard", this.editedItem);
            this.$store.commit({
              type: "showSnackbar",
              color: "success",
              message: this.$t("msgSuccessAdd"),
            });
          } catch (error) {
            this.$store.commit({
              type: "showSnackbar",
              color: "error",
              message: error,
            });
          }
        }
        this.close();
      }
    },
  },
  created() {
    this.$store.dispatch("getGiftCard", {
      client: this.$store.state.storeClient.client.basicSettings.name,
      closed: false,
    });
  },
};
</script>
